module.exports = __webpack_public_path__ + "img/world-cup.b6333b87.svg";